"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isSupportedPlan = void 0;
var request_1 = require("../types/request");
var isSupportedPlan = function (plan) { return plan in request_1.BillingPlans; };
exports.isSupportedPlan = isSupportedPlan;
